/**
 * GitHub Repositories Hook
 *
 * Fetches the list of GitHub repositories available via the org's GitHub integration.
 * Used by the create template dialog to populate the repository selector.
 *
 * @module features/sandboxes/hooks/useGitHubRepositories
 */

import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../../../config';
import { useGitHubConnectionStatus } from './useGitHubConnectionStatus';

export type GitHubRepository = {
  id: number;
  fullName: string;
  defaultBranch: string;
};

export function useGitHubRepositories() {
  const githubStatus = useGitHubConnectionStatus();

  return useQuery({
    queryKey: ['github-repositories'],
    queryFn: async (): Promise<{ ok: boolean; repositories?: GitHubRepository[]; error?: string }> => {
      const res = await fetch(`${API_URL}/integrations/github/repositories`, {
        credentials: 'include',
      });
      return res.json();
    },
    enabled: githubStatus.data?.ok === true,
  });
}
